import { jsx as _jsx } from "nativewind/jsx-runtime";
import React, { useState } from 'react';
import { color } from '@/constant/color';
import * as S from './TextArea.style';
export default function TextInput(props) {
    const [focused, setFocused] = useState(false);
    return (_jsx(S.TextAreaContainer, { focused: focused, children: _jsx(S.Input, Object.assign({ placeholderTextColor: color.gray50, multiline: true }, props, { onFocus: () => setFocused(true), onBlur: () => setFocused(false) })) }));
}
